import { localEnv } from "./env/local-env"
import { prodEnv } from "./env/prod-env"

export const env = import.meta.env.VITE_DEV ? localEnv : prodEnv

if (import.meta.env.VITE_DEV) {
  console.log("Environment: Development")
}
